<div class="reject-dialog">
  <h2 mat-dialog-title>Red</h2>
  
  <mat-dialog-content>
    <form [formGroup]="rejectForm">
      <p>Bu talebi reddetmek istediğinizden emin misiniz?</p>
      
      <div class="info-section">
        <p><strong>Açıklama:</strong> {{data.explanation || 'Açıklama yok'}}</p>
      </div>

      <mat-form-field class="full-width">
        <mat-label>Red Nedeni</mat-label>
        <mat-select formControlName="rejectReasonId">
          <mat-option *ngFor="let reason of rejectReasons" [value]="reason.id">
            {{reason.description}}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="rejectForm.get('rejectReasonId')?.hasError('required')">
          Red nedeni seçmelisiniz
        </mat-error>
      </mat-form-field>

      <mat-form-field class="full-width">
        <mat-label>Açıklama (Opsiyonel)</mat-label>
        <textarea matInput formControlName="rejectDescription" rows="3" 
                  placeholder="Red nedeni hakkında detaylı açıklama..."></textarea>
      </mat-form-field>
    </form>
  </mat-dialog-content>
  
  <mat-dialog-actions align="end">
    <button mat-button (click)="closeModal()">İptal</button>
    <button mat-raised-button color="warn" (click)="rejectRequest()" [disabled]="rejectForm.invalid">
      <mat-icon>highlight_off</mat-icon>
      Reddet
    </button>
  </mat-dialog-actions>
</div>
